import { render } from "./ConfigurationPBX.vue?vue&type=template&id=feb8c086"
import script from "./ConfigurationPBX.vue?vue&type=script&lang=js"
export * from "./ConfigurationPBX.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__